<template>
	<el-row>
		<el-col :span="24" class="nav">
			<div class="logo-box">云喵圈子</div>
			<el-menu router mode="horizontal" background-color="#0066cc" :default-active="activeIndex" active-text-color="#fff"
			 text-color="#ccc">
				<el-menu-item @click="parents(index,item.url)" v-for="(item,index) in list" :index="item.url" :key="index">{{item.name}}</el-menu-item>
			</el-menu>
			<el-menu style="margin-left: auto;" mode="horizontal" background-color="#0066cc" active-text-color="#fff" text-color="#fff">
				<el-menu-item>
					<el-dropdown @command="handleCommand">
						<div class="header-user">
							<el-avatar class="avatar" :size="40" :src="circleUrl"></el-avatar>
							<span>{{userInfo.nickname}}</span>
							<i style="color: #FFFFFF;" class="el-icon-arrow-down el-icon--right"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="1">编辑信息</el-dropdown-item>
							<el-dropdown-item :command="2">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-menu-item>
			</el-menu>
		</el-col>
		<!-- 编辑用户信息弹窗 -->
		<el-dialog title="编辑信息" :visible.sync="dialogFormVisible">
			<el-form ref="form">
				<el-form-item label="用户名">
					<el-input v-model="userInfo.nickname" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input v-model="pwd" type="password" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="userInfoSave">保存</el-button>
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import md5 from 'js-md5';
	export default {
		props: {
			list: Array
		},
		data() {
			return {
				btnLoading: false,
				btnDisabled: false,
				circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
				userInfo: {},
				dialogFormVisible: false,
				pwd: "",
				activeIndex: ""
			};
		},
		created() {
			this.userInfo = this.$store.state.userInfo;
			this.init();
		},
		methods: {
			handleCommand(command) {

				if (command == 1) {
					this.dialogFormVisible = true;
				}

				if (command == 2) {
					this.logOut();
				}
			},
			userInfoSave() {
				let form = {};

				form.username = this.userInfo.nickname;
				form.password = md5(this.pwd);

				this.$H.post("user/editAdmin", form).then(res => {
					if (res.code == 200) {
						this.$message.success("保存成功");
						this.dialogFormVisible = false;
					}
				})
			},
			init() {
				if (!this.$store.state.sideBar) {
					this.$store.state.sideBar = this.list[0].children;
				}
				this.activeIndex = localStorage.getItem("activeIndex");
			},
			parents(index, url) {
				localStorage.setItem("sideBar", JSON.stringify(this.list[index].children));
				localStorage.setItem("activeIndex", url);
				this.$store.state.sideBar = this.list[index].children;
			},
			logOut() {
				let that = this;
				this.$store.state.Authorization = "";
				this.$store.state.userName = "";
				localStorage.removeItem("userInfo");
				this.$store.state.userInfo = "";
				this.$message({
					message: '已退出登录',
					type: 'success'
				});
				setTimeout(function() {
					that.$router.push('/login');
				}, 1500)
			}
		}
	}
</script>
<style>
	body {
		margin: 0;
	}
</style>
<style scoped>
	.nav {
		display: flex;
		align-items: center;
		background-color: #0066cc;
		padding: 15px 0;
	}

	.el-menu--horizontal>.el-menu-item {
		height: 40px;
		line-height: 40px;
		padding: 0;
		margin: 0 20px;
	}

	.el-menu--horizontal>.el-menu-item:hover {
		background-color: unset !important;
		color: #fff !important;
	}


	/* 去除菜单选中后悬停黑色背景 */
	.el-menu-item.is-active,
	.el-submenu__title.is-active {
		background: unset !important;
	}

	.el-menu.el-menu--horizontal {
		border: 0;
	}

	.logo-box {
		font-size: 40px;
		margin-left: 50px;
		margin-right: 100px;
		color: #fff;
		font-weight: bold;
	}

	.header-user {
		display: flex;
		align-items: center;
		color: #FFFFFF;
	}

	.avatar {
		margin-right: 5px;
	}
</style>
